import styled from 'styled-components';

import { COLORS } from '../../../theme/tokens';

export const Screen = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: ${COLORS.heroBg};
`;

export const Card = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 28px;
  border: 1px solid ${COLORS.featureCardBorder};
  border-radius: 16px;
  background: ${COLORS.surfaceCard};
  text-align: center;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${COLORS.text};
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${COLORS.textMuted};
`;
